// extracted by mini-css-extract-plugin
export var carouselDots = "Carousel-module--carouselDots--19535";
export var content = "Carousel-module--content--b8254";
export var customCarousel = "Carousel-module--customCarousel--0f1d5";
export var dark = "Carousel-module--dark--b68fd";
export var nextArrow = "Carousel-module--nextArrow--82a75";
export var prevArrow = "Carousel-module--prevArrow--75f83";
export var testimonialWrapper = "Carousel-module--testimonialWrapper--05e99";